import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cognitoAuthService } from '../services/cognitoAuth';
import Header from '../components/Header';
import Footer from '../components/Footer';

type User = {
  name?: string;
  email?: string;
  subscriptionStatus?:
    | 'free'
    | 'trial'
    | 'active'
    | 'canceled'
    | 'past_due'
    | 'expired';
  trialEndDate?: string;
};

const SubscriptionSuccessPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(['subscription', 'common']);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const isAuth = await cognitoAuthService.isAuthenticated();
        if (!isAuth) {
          history.push('/login');
          return;
        }

        const attributes = await cognitoAuthService.getUserAttributes();
        if (attributes) {
          setUser({
            name: attributes.name || attributes.email,
            email: attributes.email,
            subscriptionStatus: 'active',
          });
        }
      } catch (error) {
        console.error('Error loading user:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [history]);

  if (loading) {
    return (
      <div
        className='min-h-screen flex items-center justify-center'
        style={{ background: 'rgb(8 6 20 / 100%)' }}
      >
        <div className='text-center animate-fade-in'>
          <div className='spinner glow mx-auto mb-6'></div>
          <p className='text-base' style={{ color: 'var(--text-secondary)' }}>
            {t('common:loading')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='page'>
      <Header variant='player' />
      <div className='container-mobile'>
          <div className='text-center mb-4'>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '48px 0 12px 0',
              }}
            >
              <div className='success-icon-wrapper'>
                <svg
                  className='w-12 h-12 text-white'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={3}
                    d='M5 13l4 4L19 7'
                  />
                </svg>
              </div>
            </div>

            <h1
              style={{
                fontSize: '24px',
                fontWeight: '700',
                color: 'var(--text-primary)',
                marginBottom: '4px',
                fontFamily: 'Lexend Deca, sans-serif',
              }}
            >
              {t('subscription:success.title')}
            </h1>
            <p
              style={{
                color: 'var(--text-secondary)',
                fontSize: '16px',
                lineHeight: '1.5',
                maxWidth: '600px',
                margin: '0 auto',
              }}
            >
              {t('subscription:success.message')}
            </p>
          </div>

          <div className='text-center mt-8 flex justify-center items-center gap-4'>
            <button
              onClick={() => history.push('/tracks')}
              className='btn btn-secondary'
            >
              {t('subscription:success.exploreTracks')}
            </button>
            <button
              onClick={() => history.push('/subscription')}
              className='btn btn-primary'
            >
              {t('subscription:success.manageSubscription')}
            </button>
          </div>
        </div>

        <Footer />
      </div>
  );
};

export default SubscriptionSuccessPage;
